import { HttpClient } from "services/httpClient/HttpClient";
import { ApiError } from "./types/ApiError";

export const IdentifierApi = {
  getToken: (identifier: string): Promise<ApiError> => {
    return HttpClient.get<ApiError>(`enterprise/identifier?token=${identifier}`,);
  }
};